import axios from '@/libs/api.request'

/**
 * 获取通讯录列表
 * @returns {wx.RequestTask | never}
 */
export const getList = (params) => {
  return axios.request({
    url: 'main/addressBook/getList',
    method: 'get',
    params: params
  })
}
/**
 * 更新通讯录
 * @returns {wx.RequestTask | never}
 */
export const saveAddressBook = (data) => {
  return axios.request({
    url: 'main/addressBook/saveAddressBook',
    method: 'post',
    data
  })
}
/**
 * 获取订单列表
 * @returns {wx.RequestTask | never}
 */
export const getOrderList = (params) => {
  return axios.request({
    url: 'main/addressBook/getOrderList',
    method: 'get',
    params
  })
}
/**
 *
 * @returns {wx.RequestTask | never}
 */
export const getApplyList = (params) => {
  return axios.request({
    url: 'main/addressBook/getApplyList',
    method: 'get',
    params
  })
}
/**
 *
 * @returns {wx.RequestTask | never}
 */
export const delBook = (data) => {
  return axios.request({
    url: 'main/addressBook/delBook',
    method: 'post',
    data
  })
}
